// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import { ISessionResponse } from "./types";

export const SESSION_RESPONSE = "SESSION_RESPONSE";
export const RESET_SESSION = "RESET_SESSION";

interface SessionAction {
  type: typeof SESSION_RESPONSE;
  message: ISessionResponse;
}

interface ResetSessionAction {
  type: typeof RESET_SESSION;
}

export type SessionActionTypes = SessionAction | ResetSessionAction;

export function saveSessionResponse(message: ISessionResponse) {
  return {
    type: SESSION_RESPONSE,
    message: message,
  };
}

export function resetSession() {
  return {
    type: RESET_SESSION,
  };
}
